module.exports = __webpack_public_path__ + "img/深州精品水果.3523d62e.jpg";